import React from 'react';

const WorkStartProcess = () => {
    return (
        <div className="work-start-process-wrapper">
            <h2 className="process-title text-center">
                فرآیند شروع کار
            </h2>
            <div className="container process-container">
                <div className="steps-wrapper d-lg-flex align-items-center justify-content-center xpr-10 xpr-lg-0">
                    <div className="step step--1 position-relative xmb-0 xmb-lg-3">
                        <img src="./assets/vendorImages/Path 13456.png" alt="ss"
                             className="next-step-line position-absolute"/>
                        <div className="image-content xml-3 xml-lg-0 xmt-0 xmt-lg-3">
                            <img src="./assets/vendorImages/login.png" alt="asdf" className="image-content"/>
                        </div>
                        <div className="step-text position-absolute">
                            <p className="text">
                                ثبت نام درپنل
                                فروشندگان سایمان
                            </p>
                        </div>
                        <span className="step-number persian-number position-absolute">01</span>
                    </div>
                    <div className="step step--2 position-relative xmb-0 xmt-0 xmt-lg-3">
                        <img src="./assets/vendorImages/Path 13454.png" alt="d"
                             className="next-step-line position-absolute"/>
                        <div className="image-content xml-3 xml-lg-0 xmb-0 xmb-lg-3">
                            <img src="./assets/vendorImages/112-book-morph-outline.png" alt="asdf"
                                 className="image-content"/>
                        </div>
                        <div className="step-text position-absolute">
                            <p className="text">
                                شرکت در کارگاه آموزشی
                                حضوری یا آنلاین
                            </p>
                        </div>
                        <span className="step-number persian-number position-absolute">02</span>
                    </div>
                    <div className="step step--3 position-relative xmb-0 xmb-lg-3">
                        <img src="./assets/vendorImages/Path 13456.png" alt="ss"
                             className="next-step-line position-absolute"/>
                        <div className="image-content xml-3 xml-lg-0 xmt-0 xmt-lg-3">
                            <img src="./assets/vendorImages/Group 3926.png" alt="asdf"/>
                        </div>
                        <div className="step-text position-absolute">
                            <p className="text">
                                درج اطلاعات کالا در پنل
                                فروشندگان سایمان
                            </p>
                        </div>
                        <span className="step-number persian-number position-absolute">03</span>
                    </div>
                    <div className="step step--4 position-relative xmb-0 xmt-0 xmt-lg-3">
                        <img src="./assets/vendorImages/Path 13454.png" alt="d"
                             className="next-step-line position-absolute"/>
                        <div className="image-content xml-3 xml-lg-0 xmb-0 xmb-lg-3">
                            <img src="./assets/vendorImages/Group 3920.png" alt="asdf"/>
                        </div>
                        <div className="step-text position-absolute">
                            <p className="text">
                                تایید کالای درج شده توسط
                                کارشناسان سایمان
                            </p>
                        </div>
                        <span className="step-number persian-number position-absolute">04</span>
                    </div>
                    <div className="step step--5 position-relative xmb-0 xmb-lg-3">
                        <img src="./assets/vendorImages/Path 13456.png" alt="ss"
                             className="next-step-line position-absolute"/>
                        <div className="image-content xml-3 xml-lg-0 xmt-0 xmt-lg-3">
                            <img src="./assets/vendorImages/Path 13286.png" alt="asdf"/>
                        </div>
                        <div className="step-text position-absolute">
                            <p className="text">
                                قیمت‌گذاری کالا در پنل
                                فروشندگان سایمان
                            </p>
                        </div>
                        <span className="step-number persian-number position-absolute">05</span>
                    </div>
                    <div className="step step--6 position-relative xmb-4">

                        <div className="image-content">
                            <img src="./assets/vendorImages/1359-online-shopping-outline (1).png" alt="asdf"/>
                        </div>
                        <div className="step-text position-absolute green-step">
                            <p className="text">
                                قیمت‌گذاری کالا در پنل فروشندگان سایمان
                            </p>
                        </div>
                        <span className="step-number persian-number position-absolute green-step">06</span>
                    </div>
                </div>
                <div className="more-info-button">
                    <a href="#" className="button"><span
                        className="text">اطلاعات بیشتر در مورد فرآیند شروع کار</span></a>
                </div>
            </div>
        </div>
    );
};

export default WorkStartProcess;
